/** Whether a before and after slider wiggles once when it scrolls into view. */
const SliderWiggleField = {
  type: "radio",
  label: "Slider wiggle",
  options: [
    { label: "On", value: "on" },
    { label: "Off", value: "off" },
  ],
  metadata: {
    source: "manual",
    description: "The slider moves a little when it first comes into view, so visitors see they can drag it.",
  },
} as const;

type SliderWiggle = "on" | "off";

export type { SliderWiggle };
export { SliderWiggleField };
